module.exports = __webpack_public_path__ + "img/37.c2646623.jpg";